import { render, staticRenderFns } from "./erfan.vue?vue&type=template&id=27a3f433"
import script from "./erfan.vue?vue&type=script&lang=js"
export * from "./erfan.vue?vue&type=script&lang=js"
import style0 from "./erfan.vue?vue&type=style&index=0&id=27a3f433&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports